<template>
  <Dialog
    header="Cliente"
    :style="{ width: '35vw' }"
    :modal="true"
    :closable="false"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
  >
    <AppForm ref="form" :rules="{}" :values="model">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12">
          <AppFormItem label="Nome">
            <InputText :disabled="true" v-model="model.name" />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <AppFormItem label="Documento">
            <InputText
              :disabled="true"
              v-model="model.document"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
            />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <AppFormItem label="Telefone">
            <InputText
              :disabled="true"
              v-model="model.phone"
              v-mask="['(##) ####-####', '(##) #####-####']"
            />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12">
          <AppFormItem label="Email">
            <InputText :disabled="true" v-model="model.email" />
          </AppFormItem>
        </div>
      </div>
    </AppForm>
    <template #footer>
      <div class="p-grid p-jc-between">
        <div style="padding-left: 8px">
          <Button
            label="Remover"
            class="p-button-outlined p-button-danger"
            icon="pi pi-trash"
            @click="remove()"
          />
        </div>
        <div style="padding-right: 8px">
          <Button
            label="Cancelar"
            class="p-button-outlined p-mr-2"
            @click="cancel()"
          />
          <AppButton
            v-if="!initialData.accepted"
            label="Aceitar"
            :loading="loading"
            @click="accept()"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { VetCustomerApi } from '../../../services/api';

export default {
  name: 'VetDialog',
  props: {
    visible: Boolean,
    initialData: Object,
  },
  data() {
    return {
      model: {
        inviteCode: null,
        name: null,
        document: null,
        phone: null,
        email: null,
      },
      loading: false,
      loadingCheck: false,
      error: {
        code: null,
      },
    };
  },
  emits: ['accept', 'remove'],
  watch: {
    visible(newValue, oldValue) {
      if (newValue && !oldValue && this.initialData) {
        this.model = {
          ...this.initialData.account,
          _id: this.initialData.id,
        };
      }
    },
  },
  methods: {
    async accept() {
      try {
        this.loading = true;
        await VetCustomerApi.accept(this.model._id);
        this.$emit('update:visible', false);
        this.$emit('accept');
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$emit('update:visible', false);
    },
    async remove() {
      await VetCustomerApi.delete(this.model._id);
      this.$emit('update:visible', false);
      this.$emit('remove');
    },
  },
};
</script>

<style scoped>
</style>
